import { Component } from '@angular/core';
import { Router } from '@angular/router';

interface TeamMember {
  name: string;
  title: string;
  description: string;
  imageUrl: string;
   showFullDescription?: boolean;
}

@Component({
  selector: 'app-instructors',
  templateUrl: './instructors.component.html',
  styleUrls: ['./instructors.component.scss']
})
export class InstructorsComponent {
teamMembers: TeamMember[] = [];

  constructor(private router: Router) { }

  ngOnInit(): void {
    // Populate team members data
    this.teamMembers = [
  {
    name: 'Lyssa deHart',
    title: 'Lyssa deHart, LICSW, MCC, BCC, EMCC, is a respected author, coaching educator, and "recovering therapist."',
    description: 'Lyssa is an ICF Master Certified Coach and sought-after coaching educator who blends neuroscience, psychology, and the ICF Core Competencies into practical, real-world coaching. She is the author of StoryJacking, The Reflective Coach, Light Up: The Science of Coaching with Metaphors, and the upcoming Sticky Outcomes. Through her exam prep programs and mentor coaching, she has helped thousands of coaches around the world deepen their presence, listening, and client-led partnership. As host of The Coaching Studio Podcast, Lyssa regularly interviews thought leaders across coaching and psychology, bringing fresh insight and practical wisdom to the global coaching community.',
    imageUrl: '../../../assets/instructors/Lyssa deHart.png',
    showFullDescription: false
  },
  {
    name: 'Jake Mannino',
    title: 'Helping humanity thrive through iconic leadership, adaptive momentum, and signal clarity.',
    description: 'Jake is a senior global sales and strategy leader who has helped drive more than $1B in revenue impact across technology, SaaS, and cybersecurity. At Microsoft, he co-led a record-breaking internal coaching initiative that reached over 12,000 employees and earned a Guinness World Record for scalable culture transformation. He is known for helping executives develop clarity, resilience, and strategic influence in fast-moving environments. Jake’s work sits at the intersection of leadership, AI, and human performance, guiding leaders to harness modern tools while strengthening their human edge. Jake is deeply committed to developing leaders who can communicate with precision, think strategically under pressure, and create momentum within their organizations.',
    imageUrl: '../../../assets/instructors/Jake.jpg',
    showFullDescription: false
  },
  {
    name: 'Rob Brunhild',
    title: 'Rob is a seasoned business executive with over 30 years experience working in Fortune 500 companies as well as high-growth environments.',
    description: 'In his coaching practice, Rob partners with individuals and teams to help them solve everyday challenges, maximize productivity, further strategic goals, and produce superior outcomes. Rob has extensive coaching experience as well as senior leadership roles in Enterprise Sales, Operations, and Delivery Management. He believes the value of the relationships one builds is as important as the products one creates, and that lasting connections with internal and external stakeholders drive productivity, innovation, and career success. Rob passionately adheres to the core value of “Being True” by engaging colleagues and customers with integrity, trust, and respect.',       
    imageUrl: '../../../assets/instructors/ROB.jpg',
    showFullDescription: false
  }
];

  }

  openWebsite(url: string) {
  this.router.navigate(['/instructor-viewer'], { queryParams: { url } });
  }


  ngAfterViewInit(): void {
  const cards = document.querySelectorAll('.card');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        (entry.target as HTMLElement).style.animationPlayState = 'running';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  cards.forEach(card => {
    (card as HTMLElement).style.animationPlayState = 'paused';
    observer.observe(card);
  });
}
}
